import React from 'react';
import PropTypes from 'prop-types';
import KeyStore from 'utils/KeyStore';
import { makeStyles } from '@material-ui/core';
import { EmployeeType } from 'utils/enum/UserEnum';
import PayrollBaseList from 'components/modules/payroll/read/PayrollBaseList';
import TechnicianCommissionTable from 'components/widgets/payroll/TechnicianCommission/TechnicianCommissionTable';
import TechnicianPaidCommissionTable from 'components/widgets/payroll/TechnicianCommission/TechnicianPaidCommissionTable';

const useStyles = makeStyles(() => ({
    defaultText: {
        height: '100%',
        textAlign: 'center',
        alignContent: 'center',
    },
}));

const TechnicianCommissionList = () => {
    const classes = useStyles();
    const keyStore = new KeyStore();
    const savedSizes = keyStore.getTechnicianCommissionSplitSize() || [50, 50];

    const onResizingSplit = (size) => {
        keyStore.setTechnicianCommissionSplitSize(size);
    };

    const getRightSideComponent = ({
        employeeId, payPeriod, displayPaidCommissions, payPeriodYear,
    }) => (
        <div>
            {(employeeId <= 0 || !payPeriod) && (
                <div className={classes.defaultText}>No display Available</div>
            )}
            {employeeId > 0 && Boolean(payPeriod) && !displayPaidCommissions && (
                <TechnicianCommissionTable
                    payPeriod={payPeriod}
                    employeeId={employeeId}
                />
            )}
            {employeeId > 0 && Boolean(payPeriod) && displayPaidCommissions && (
                <TechnicianPaidCommissionTable
                    year={payPeriodYear}
                    employeeId={employeeId}
                />
            )}
        </div>
    );

    getRightSideComponent.propTypes = {
        payPeriod: PropTypes.string.isRequired,
        employeeId: PropTypes.number.isRequired,
        payPeriodYear: PropTypes.number.isRequired,
        displayPaidCommissions: PropTypes.bool.isRequired,
    };

    return (
        <PayrollBaseList
            displayPaidOnlySwitch
            splitSize={savedSizes}
            onResizingSplit={onResizingSplit}
            employeeType={EmployeeType.TECHNICIAN}
            getRightSideComponent={getRightSideComponent}
        />
    );
};

export default TechnicianCommissionList;
